export default "__VITE_ASSET__CayQii1D__"